<template>
	<div style="background-color: #ddd;height:100vh;padding:200px 0;">
		<div
    style="width:600px;margin:auto;background-color: #fff;padding:16px;border:1px solid #ccc;border-top:2px solid #00a4ff;box-shadow:rgba(122, 55, 55, 0.2) 0px 1px 1px 0px;"
		>
    <div>
      <img src="https://cloudcache.tencent-cloud.com/qcloud/portal/kit/images/slice/logo.23996906.svg" />
    </div>
    <div style="margin-top:16px;">
			尊敬的腾讯云用户，您好！ 您的腾讯云数据库已到期。<br/>
      截止北京时间{{ date }} 23:00:00，由于您的账户余额不足无法完成自动续费。<br/>
			资源停服后将无法正常使用，资源释放后数据将被移除，不可恢复。<br/>
			为了保障您的服务正常运行及数据安全，请及时续费或备份数据，系统将在余额充足时为您续费自动续费资源。
    </div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      date: moment().subtract(1, 'days').format('YYYY-MM-DD')
    }
  },
  mounted () {
    this.$http.get('/auth/info').then(() => {
      localStorage.removeItem('kaochang.token')
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Expiry.vue